import { Card, CardContent } from '@/components/ui/card';
import { Mail, ShoppingCart, TrendingUp, DollarSign, ShoppingBag } from 'lucide-react';
import { useLanguage } from '@/i18n/LanguageContext';

export const ReminderStatsCard = ({ reminderStats }) => {
  const { t } = useLanguage();
  return (
    <Card className="bg-card border-border mb-10" data-testid="reminder-stats-card">
      <CardContent className="p-6">
        <h3 className="text-lg font-bold mb-1">{t('analytics.reminderStatsTitle')}</h3>
        <p className="text-sm text-muted-foreground mb-6">{t('analytics.reminderStatsDesc')}</p>
        <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
          <div className="bg-card border border-border rounded-sm p-4">
            <div className="flex items-center gap-2 mb-1 text-muted-foreground">
              <Mail className="w-4 h-4" />
              <p className="text-xs">{t('analytics.remindersSent')}</p>
            </div>
            <p className="text-2xl font-bold font-mono" data-testid="reminder-sent-count">{reminderStats.sent}</p>
          </div>
          <div className="bg-card border border-border rounded-sm p-4">
            <div className="flex items-center gap-2 mb-1 text-muted-foreground">
              <ShoppingCart className="w-4 h-4" />
              <p className="text-xs">{t('analytics.remindersRecovered')}</p>
            </div>
            <p className="text-2xl font-bold font-mono" data-testid="reminder-recovered-count">{reminderStats.recovered}</p>
          </div>
          <div className="bg-card border border-border rounded-sm p-4">
            <div className="flex items-center gap-2 mb-1 text-muted-foreground">
              <TrendingUp className="w-4 h-4" />
              <p className="text-xs">{t('analytics.recoveryRate')}</p>
            </div>
            <p className="text-2xl font-bold font-mono text-primary" data-testid="reminder-recovery-rate">
              {reminderStats.recovery_rate}%
            </p>
          </div>
          <div className="bg-card border border-border rounded-sm p-4">
            <div className="flex items-center gap-2 mb-1 text-muted-foreground">
              <DollarSign className="w-4 h-4" />
              <p className="text-xs">{t('analytics.recoveredRevenue')}</p>
            </div>
            <p className="text-2xl font-bold font-mono text-primary" data-testid="reminder-recovered-revenue">
              CHF {Number(reminderStats.recovered_revenue || 0).toFixed(2)}
            </p>
          </div>
          <div className="bg-card border border-border rounded-sm p-4">
            <div className="flex items-center gap-2 mb-1 text-muted-foreground">
              <ShoppingBag className="w-4 h-4" />
              <p className="text-xs">{t('analytics.openCarts')}</p>
            </div>
            <p className="text-2xl font-bold font-mono" data-testid="reminder-open-carts">{reminderStats.open_carts}</p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
